import { retrieveToken } from '../storage';
import {
  wrapFetch,
  wrapFetchWithDetailedErrors,
  apiFetch,
  apiError,
  OPERAZIONE_NON_CONSENTITA,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getRevisioniManuali = (
  id,
  hidden,
  gruppoId,
  consulenteId,
  page,
  size,
  sortby,
  esercizioId,
  esercizioNome,
  manualeId,
  manualeTitolo,
  tipologiaRevisione,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/revisioni';
  let query = `?page=${page}&size=${size}&personalizzato.equals=true&sort=${sortby}&${sortby}.dir=ASC&hidden.equals=${hidden}`;

  if (id !== null) {
    query += '&id.equals=' + id;
  }
  if (consulenteId !== null) {
    query += '&consulenteId.equals=' + consulenteId;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query += '&gruppoId.equals=' + gruppoId;
  }
  if (esercizioId) {
    query += `&esercizioCommercialeId.equals=${esercizioId}`;
  }
  if (esercizioNome) {
    query += `&nomeEsercizio.contains=${encodeURIComponent(esercizioNome)}`;
  }
  if (manualeId) {
    query += `&manualeId.equals=${manualeId}`;
  }
  if (manualeTitolo) {
    query += `&titoloManuale.contains=${encodeURIComponent(manualeTitolo)}`;
  }
  if (tipologiaRevisione) {
    query += `&tipologiaRevisione.equals=${tipologiaRevisione}`;
  }
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const getStatoFile = (revisioneId, stato) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/storage?revisioneId=' + revisioneId + '&tipo=' + stato;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getStatoFileWithEsercizio = (revisioneId, stato, esercizio) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);

  // Controlla se lo stato è 'IN_ATTESA_PAGAMENTO' e imposta 'tipo' a 'BOZZA'
  const tipo = stato === 'IN_ATTESA_PAGAMENTO' ? 'BOZZA' : stato;

  const PATH = `/api/storage?revisioneId=${revisioneId}&tipo=${tipo}&esercizioId=${esercizio}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getTotaleRevisioniManuali = (
  id,
  hidden,
  gruppoId,
  consulenteId,
  esercizioId,
  esercizioNome,
  manualeId,
  manualeTitolo,
  tipologiaRevisione,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/revisioni/count';
  let query = `?personalizzato.equals=true&hidden.equals=${hidden}`;
  if (id !== null) {
    query += '&id.equals=' + id;
  }
  if (consulenteId !== null) {
    query += '&consulenteId.equals=' + consulenteId;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query += '&gruppoId.equals=' + gruppoId;
  }
  if (esercizioId) {
    query += `&esercizioCommercialeId.equals=${esercizioId}`;
  }
  if (esercizioNome) {
    query += `&nomeEsercizio.contains=${encodeURIComponent(esercizioNome)}`;
  }
  if (manualeId) {
    query += `&manualeId.equals=${manualeId}`;
  }
  if (manualeTitolo) {
    query += `&titoloManuale.contains=${encodeURIComponent(manualeTitolo)}`;
  }
  if (tipologiaRevisione) {
    query += `&tipologiaRevisione.equals=${tipologiaRevisione}`;
  }
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getRevisioneManuale = (revisioneId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/revisioni/' + revisioneId;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      404: 'Revisione manuale non trovata.',
    }),
  );
};

export const updateRevisioneManuale = (revisione) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/revisioni';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(revisione),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Errore salvataggio: revisione manuale non trovata.',
    }),
  );
};

export const cancellaRevisione = (id, hidden) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/revisioni/cancella';
  const URL = BASE_URL + PATH;
  const requestBody = {
    id: id,
    hidden: hidden,
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // Error 404 if ID does not correspond to an existing record:
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: SALVATAGGIO_DATI_NON_CORRETTI,
    }),
  );
};

// New API call for publishing a Manuale 'personalizzato'
export const pubblicaManuale = (manualeId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali/personalizzati/' + manualeId + '/pubblicazione';
  const URL = BASE_URL + PATH;
  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      400: "Pubblicazione fallita: assicurarsi che l'esercizio commerciale collegato al manuale da pubblicare abbia accettato i termini d'uso e/o la privacy policy del servizio BS-FOOD.",
      401: OPERAZIONE_NON_CONSENTITA,
      403: "Il servizio è in attesa del pagamento del canone annuale per l'esercizio commerciale selezionato.",
    }),
  );
};
